import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VideoModalComponent } from '../video-modal/video-modal.component';

@Component({
  selector: 'app-admin-test-page',
  templateUrl: './admin-test-page.component.html',
  styleUrls: ['./admin-test-page.component.scss']
})
export class AdminTestPageComponent implements OnInit {

  public actionResults: string = "Nada efetuado";

  constructor(
    private modalService: NgbModal
  ) { }

  async showModal(component: any, componentInputs?: Record<string, any>): Promise<boolean> {
    try {
      const modalRef = this.modalService.open(component, { ariaLabelledBy: 'modal' });
      // Set component instance inputs with parameter object key/value pairs
      if (componentInputs) {
        for (let property in componentInputs) {
          modalRef.componentInstance[property] = componentInputs[property];
        }
      }
      const result = await modalRef.result;
      return result;
    } catch(reason) {
      // Continue regardless of error
    }
    return null;
  }

  ngOnInit() {
  }

  async onActionClick() {
    this.actionResults = "Carregando...";
    const videoWidth = window.innerWidth * 0.8 | 0;
    await this.showModal(VideoModalComponent, {
      modalTitle: "Reportsfeed - Microsoft Azure",
      videoUrl: "/assets/videos/ReportsFeed - Microsoft Azure EN.webm",
      videoWidth
    });
    this.actionResults = "Done";
  }

}
